"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.docComplete = exports.getUpdatedMultipleAccessoryPromos = exports.getBsseTax = exports.updateAccessoryQuantity = exports.buildAccessoryQuantityCartData = exports.buildRemoveAccessoryCartData = exports.checkIfProd = exports.isEmptyObject = exports.isKeyExist = exports.isEmpty = exports.getFormatedDate = exports.isModalOpen = exports.replaceAmpWithAnd = exports.replaceHTMLNdash = exports.replaceHTMLEntities = void 0;
var CartActions_1 = require("../models/requests/CartActions");
var wlsUtils = require("./WirelessUtilFunctions");
var Utils = require("./UtilityFunctions");
var _ = require('lodash');
var NUM_ONLY_REGEX = new RegExp('^[0-9]*$');
function replaceHTMLEntities(content) {
    if (content) {
        var str = content.replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&amp;amp;/g, '&')
            .replace(/&amp;#8217;/g, '’')
            .replace(/&amp;#8211/g, '&ndash;');
        return str;
    }
    else {
        return '';
    }
}
exports.replaceHTMLEntities = replaceHTMLEntities;
function replaceHTMLNdash(content) {
    if (content) {
        var str = content.replace(/&amp;#8211/g, '&ndash;');
        return str;
    }
    else {
        return '';
    }
}
exports.replaceHTMLNdash = replaceHTMLNdash;
function replaceAmpWithAnd(content) {
    // issue was "displayName": "Nokia 3.1 A - AT&amp;amp;amp;amp;amp;amp;amp;amp;amp;T PREPAID - 32GB - Black",
    if (content) {
        var str = content.replace(/amp;/g, '');
        return str;
    }
    else {
        return '';
    }
}
exports.replaceAmpWithAnd = replaceAmpWithAnd;
function isModalOpen() {
    var modalElement = document.getElementById('modalDialogdOnOpen');
    if (modalElement) {
        return true;
    }
    else {
        return false;
    }
}
exports.isModalOpen = isModalOpen;
function getFormatedDate(value, isfullMonth, omitYear) {
    var regPattern = /(\d{4})\-(\d{2})\-(\d{2})$/;
    if (value && regPattern.test(value)) {
        return value.replace(regPattern, function (match, p1, p2, p3) {
            var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var fullmonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
                'October', 'November', 'December'];
            if (isfullMonth) {
                return fullmonths[(p2 - 1)] + " " + p3 + ", " + p1;
            }
            else if (omitYear) {
                return months[(p2 - 1)] + " " + p3;
            }
            else {
                return months[(p2 - 1)] + " " + p3 + ", " + p1;
            }
        });
    }
    else {
        return value;
    }
}
exports.getFormatedDate = getFormatedDate;
function isEmpty(value) {
    return (value === null || typeof value === 'undefined' || (value === ''));
}
exports.isEmpty = isEmpty;
// tslint:disable-next-line:no-any
function isKeyExist(obj, key) {
    if (isEmpty(key)) {
        return false;
    }
    return key.split('.').every(function (s) {
        if (isEmptyObject(obj) || !obj.hasOwnProperty(s)) {
            return false;
        }
        obj = obj[s];
        return true;
    });
}
exports.isKeyExist = isKeyExist;
function isEmptyObject(obj) {
    return (obj === null
        || typeof obj === 'undefined'
        || typeof obj !== 'object'
        || (Object.keys(obj).length === 0));
}
exports.isEmptyObject = isEmptyObject;
function checkIfProd() {
    var isProd = true;
    var hostname = window && window.location.hostname && window.location.hostname.replace('www.', '');
    if (hostname !== 'att.com') {
        isProd = false;
    }
    return isProd;
}
exports.checkIfProd = checkIfProd;
function buildRemoveAccessoryCartData(losg, lineItem, payload) {
    var _a;
    var isCommonCart = !!(payload && payload.commonCart);
    var splitAccessory = (((_a = Utils.getCartResp()) === null || _a === void 0 ? void 0 : _a.enableSplitAccessoryLine) === true) ? true : false;
    var correctLosgId = (splitAccessory) ? ((lineItem === null || lineItem === void 0 ? void 0 : lineItem._parentLosgId) ? lineItem._parentLosgId : losg.id) : losg.id;
    var itemPostData = {
        action: CartActions_1.ActionType.REMOVE,
        extraData: {
            invocationSource: 'cart',
        },
        itemId: lineItem.id,
        itemType: CartActions_1.ItemType.ACCESSORY,
        losgId: correctLosgId,
        losgType: losg.losgType,
        productGroup: losg.productCategory || CartActions_1.ProductGroupType.WIRELESS,
        productSKU: lineItem.productSKU,
        quantity: 1,
    };
    if (isCommonCart && losg.losgType === 'AL') {
        var alParam = wlsUtils.buildLineItemExtraParam(payload, losg.id);
        itemPostData.accountId = alParam.accountId;
        itemPostData.productRootId = alParam.productRootId;
        itemPostData.primaryPlanSubscriber = alParam.primaryPlanSubscriber;
    }
    var removeCartRequest = {
        itemsList: [itemPostData],
        serviceContext: {
            srcSystem: 'IDSE',
        },
        shoppingContext: wlsUtils.buildShoppingContext(payload, losg.losgType),
    };
    return removeCartRequest;
}
exports.buildRemoveAccessoryCartData = buildRemoveAccessoryCartData;
function buildAccessoryQuantityCartData(key, lineItem, losg, payload) {
    var _a;
    var updateCartRequest = {
        itemsList: [],
        serviceContext: {
            srcSystem: 'IDSE',
        },
    };
    var splitAccessory = (((_a = Utils.getCartResp()) === null || _a === void 0 ? void 0 : _a.enableSplitAccessoryLine) === true) ? true : false;
    var correctLosgId = (splitAccessory) ? ((lineItem === null || lineItem === void 0 ? void 0 : lineItem._parentLosgId) ? lineItem._parentLosgId : losg.id) : losg.id;
    var itemPostData = {
        action: (key === 0) ? CartActions_1.ActionType.REMOVE : CartActions_1.ActionType.MODIFY,
        itemId: lineItem.id,
        itemType: CartActions_1.ItemType.ACCESSORY,
        losgId: correctLosgId,
        losgType: losg.losgType,
        offerId: lineItem.offerId,
        productGroup: losg.productCategory || CartActions_1.ProductGroupType.WIRELESS,
        productSKU: lineItem.productSKU,
        quantity: (key === 0) ? 1 : key,
    };
    var isCommonCart = !!(payload && payload.commonCart);
    if (isCommonCart && losg.losgType === 'AL') {
        var alParam = wlsUtils.buildLineItemExtraParam(payload, losg.id);
        itemPostData.accountId = alParam.accountId;
        itemPostData.productRootId = alParam.productRootId;
        itemPostData.primaryPlanSubscriber = alParam.primaryPlanSubscriber;
    }
    if ((key || key === 0) && lineItem && losg && losg.id && lineItem.id) {
        updateCartRequest = {
            itemsList: [itemPostData],
            serviceContext: {
                srcSystem: 'IDSE',
            },
            shoppingContext: wlsUtils.buildShoppingContext(payload, losg.losgType),
        };
    }
    return updateCartRequest;
}
exports.buildAccessoryQuantityCartData = buildAccessoryQuantityCartData;
function updateAccessoryQuantity(key, losg, lineItem, payload) {
    return buildAccessoryQuantityCartData(key, lineItem, losg, payload);
}
exports.updateAccessoryQuantity = updateAccessoryQuantity;
function getBsseTax(losg, priceType) {
    var taxAmount;
    if (losg && losg.priceSummaryList && priceType) {
        var priceTypeVal = priceType.toUpperCase();
        var priceSummaryList = losg.priceSummaryList;
        for (var _i = 0, priceSummaryList_1 = priceSummaryList; _i < priceSummaryList_1.length; _i++) {
            var item = priceSummaryList_1[_i];
            if (item && item.priceType === priceTypeVal &&
                item.taxSummary && item.taxSummary.length > 0) {
                taxAmount = item.taxSummary[0].amount;
                break;
            }
        }
    }
    else {
        taxAmount = null;
    }
    return taxAmount;
}
exports.getBsseTax = getBsseTax;
exports.getUpdatedMultipleAccessoryPromos = function (cartPromos) {
    var updatedAccessoryPromos = [];
    // create a dictionary object with key as promotionId and value as the array of duplicate promotions
    var groupedCartPromosDictionary = _.groupBy(cartPromos, function (promotion) {
        return (promotion.promotionId || promotion.promotionName);
    });
    // iterate though the dictionary object's values( i.e duplicate promotions array)
    Object.values(groupedCartPromosDictionary).map(function (dupPromosArr) {
        // set the promotion amount of the first promotion to be
        // the sum of the all the duplicate promotion amounts in the array
        dupPromosArr[0].totalAmount = dupPromosArr[0].amount = dupPromosArr.reduce(function (promotionAmountAccumulator, promotion) { return promotionAmountAccumulator +
            (Number(promotion.totalAmount) || Number(promotion.amount)); }, 0);
        // set accessory promos with updated first promo along with total amount
        updatedAccessoryPromos.push(dupPromosArr[0]);
    });
    return updatedAccessoryPromos;
};
exports.docComplete = function (handleDocumentComplete) {
    if (process && typeof window && document) {
        document.removeEventListener('readystatechange', handleDocumentComplete);
        if (document.readyState === 'interactive') {
            document.addEventListener('readystatechange', handleDocumentComplete, false);
        }
        else {
            setTimeout(handleDocumentComplete, 2);
        }
    }
};
//# sourceMappingURL=CommonUtilFuntions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/utils/CommonUtilFuntions.js
// module id = 66
// module chunks = 8